import { useEffect } from "react";

/**
 * Iubenda is the official source of TIME Inside's legal documents.
 * This route is preserved and redirects to the official Iubenda-hosted Cookie Policy.
 */
const IUBENDA_URL = "https://www.iubenda.com/privacy-policy/61078636/cookie-policy";

export default function CookiePolicyPage() {
  useEffect(() => {
    window.location.replace(IUBENDA_URL);
  }, []);

  return (
    <div
      data-testid="cookie-policy-redirect"
      className="min-h-[60vh] flex items-center justify-center px-6"
    >
      <a
        href={IUBENDA_URL}
        className="text-emerald-300 hover:text-emerald-200 underline underline-offset-4 text-sm tracking-wide"
      >
        Apri la Cookie Policy ufficiale
      </a>
    </div>
  );
}
